import React, { useState } from "react";

import {
  Cached,
  FormatListBulletedOutlined,
  GridOnOutlined,
} from "@mui/icons-material";
import { Box, Button, ButtonBase, IconButton, Typography } from "@mui/material";
// import Lottie from "lottie-react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

// import PlusGif from '../../assets/gifs/plus-animation.json';
import { FilterDropDown, SearchInput } from "../../common";
import { selectPostIds } from "../../redux/slices/postsSlice";
import SelectFlowModal from "../Modals/SelectFlowModal";

/* ============================================================================
  JobLiveHeader
============================================================================= */
const JobLiveHeader = ({
  totalPosts,
  view,
  onViewChange,
  query,
  onSearch,
  filter,
  onReload,
  onFilterChange,
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <Box>
      <Box
        borderBottom="1px solid #E9EBF0"
        height="65px"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        gap={2}
      >
        <Typography fontSize={"18px"} fontWeight={700}>
          Results
        </Typography>
        {/* <Button
          variant="main"
          sx={{ fontSize: "14px", fontFamily: "Outfit", fontWeight: 600 }}
          onClick={() => setOpen(true)}
          // endIcon={<Lottie animationData={PlusGif} loop={true} size='small' width={20} height={20} />}
        >
          Create Job
        </Button> */}
      </Box>

      <Box
        p={2}
        gap={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            display="flex"
            bgcolor="#F7F9FA"
            alignItems="center"
            gap={2}
            pl={2}
            borderRadius="8px"
            overflow="hidden"
          >
            <Typography fontWeight={500} fontSize={{ xs: ".8rem", lg: "1rem" }}>
              Total Jobs
            </Typography>
            <Typography
              sx={{
                color: "white",
                px: { xs: 1, lg: 3 },
                py: 1.2,
                fontWeight: 600,
                bgcolor: "#9048FB",
              }}
            >
              {totalPosts || 0}
            </Typography>
          </Box>

          <IconButton
            size="small"
            sx={{ border: "1px solid #B1B1B1" }}
            onClick={() => onReload()}
          >
            <Cached sx={{ fontSize: 18, color: "#B1B1B1" }} />
          </IconButton>
        </Box>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          gap={2}
        >
          <SearchInput
            placeholder="Search with role"
            value={query}
            onChange={onSearch}
            inputStyles={{ fontSize: "13px" }}
            containerStyles={{ width: { xs: "100%", lg: "26rem" } }}
          />
          <FilterDropDown
            value={filter}
            data={["All", "Active", "Inactive", "Archived"]}
            placeholder="Select Stage"
            onChange={(newStage) => onFilterChange(newStage)}
          />
          <Box
            border="1px solid #d1d1d1"
            height="46px"
            borderRadius="10px"
            display="flex"
          >
            {/* <ButtonBase
              sx={{
                width: "50px",
                bgcolor: view === "grid" ? "#F3E8FF" : "transparent",
              }}
              onClick={() => onViewChange("grid")}
            >
              <GridOnOutlined
                sx={{
                  width: "22px",
                  height: "22px",
                  color: view === "grid" ? "#9048FB" : "#4D4D4D",
                }}
              />
            </ButtonBase> */}
            <ButtonBase
              sx={{
                width: "50px",
                bgcolor: view === "list" ? "#F3E8FF" : "transparent",
              }}
              onClick={() => onViewChange("list")}
            >
              <FormatListBulletedOutlined
                sx={{
                  width: "22px",
                  height: "22px",
                  color: view === "list" ? "#9048FB" : "#4D4D4D",
                }}
              />
            </ButtonBase>
          </Box>
        </Box>
      </Box>
      <SelectFlowModal open={open} onClose={() => setOpen(false)} />
    </Box>
  );
};

const mapStateToProps = (state) => ({
  postsCount: selectPostIds(state)?.length,
});

/* Export
============================================================================= */
export default connect(mapStateToProps)(JobLiveHeader);
